GP.GPMod('RightDrawer',function(self) {
    var vent  = null;
    var _util = null;

    var data = {
        init: function() {
            vent  = self.vent;
            _util = self.app.Util;
            // data.default_pane = (GP.sdata.my_user.membership == 'FREE') ? 'MessagePane' : 'ActivityPane';
        },
        default_pane: 'ActivityPane',
        right_drawer_modules:    ["ActivityPane", "MessagePane", "FriendPane"],
        right_drawer_module_ids: ["activity-pane","message-pane","friend-pane"],
        pane_to_module_map: {
            "activity-pane": "ActivityPane",
            "message-pane":  "MessagePane",
            "friend-pane":   "FriendPane"
        },
        current_pane: '',
        last_pane: 'ActivityPane'
    };


    var util = {
        check_valid_module: function(module) {
            if ($.inArray(module, data.right_drawer_modules) > -1) {
                return true;
            }
            return false;
        },
        get_module_from_id: function(id) {
            if ($.inArray(id, data.right_drawer_module_ids) > -1) {
                return data.pane_to_module_map[id];
            }
            return false;
        },
        get_id_from_module: function(module) {
            var key;
            _.each(data.pane_to_module_map, function (obj_module, obj_id) {
                if (obj_module  === module) {
                    key = obj_id;
                }
            });
            return key;
        }
    };


    var events = {
        init: function() {
            // event handlers
            vent.on(self.moduleName+":show", events.show);
            vent.on(self.moduleName+":hide", events.hide);
            vent.on(self.moduleName+":close_if_mobile", events.close_if_mobile);
            vent.on(self.moduleName+":toggle", events.toggle);
            $('.pane-tab').click(events.toggle);
            $('#right-drawer-toggle').click(events.toggle_last);
            if (GP.sdata.is_mobile || GP.sdata.is_tablet) {
                var ignore_toggle_sidebar = ['.navbar-nav', '.navbar-toggle'];
                $('#header-inner .container').click(function(e) {
                    if (!$(e.target).closest(ignore_toggle_sidebar.join(',')).length) {
                        events.hide();
                    }
                });
            }

            GP.activity_divider = {
                recent: false,
                older: false
            };
            GP.activity_template = 'default';

            GP.reqres.setHandler(self.moduleName+':is_shown', events.is_shown);

            // show the rdrawer on initial page load only for desktop-wide
            if (MoshPit.get_size() == 'desktop-wide') {
                events.show(data.default_pane);
            }

        },
        toggle: function(e) {
            var pane = (e && e.currentTarget) ? $(e.currentTarget).data('target') : data.default_pane;
            if (!events.is_shown() || pane != data.current_pane) {
                if (MoshPit.get_size() == 'mobile') {
                    localStorage.setItem('current_scroll_position', window.scrollY);
                }

                events.show(pane);
            } else {
                events.hide();

                if (MoshPit.get_size() == 'mobile') {
                    var savedScrollPosition = localStorage.getItem('current_scroll_position');
                    if (savedScrollPosition) {
                        window.scrollTo(0, parseInt(savedScrollPosition, 10));
                        localStorage.removeItem('current_scroll_position');
                    }
                }
            }
        },
        is_shown: function() {
            return $('body').hasClass('right-drawer-shown');
        },
        show: function(pane, from_pop_state) {
            // mobile_menu & right_drawer are never shown at the same time
            vent.trigger('Header:close_mobile_menu');

            self.$el.show();

            if ($.type(pane) != 'string') {
                if ($.type(pane)  == 'object' && _util.check_obj(pane.pane)) {
                    pane = pane.pane;
                }
            }
            events.show_pane(pane, from_pop_state);
        },
        show_pane: function(pane, from_pop_state) {
            var pane_module, pane_id = '';
            if (util.check_valid_module(pane)) {
                pane_module = pane;
                pane_id = util.get_id_from_module(pane);
            } else {
                pane_id = pane;
                pane_module = util.get_module_from_id(pane);
            }

            events.hide_pane({ exclude_pane: pane_id });

            if (MoshPit.get_size() == 'mobile') {
                // if we are switching away from the message pane, close thread
                // or if we are switching to it from another pane (friend pane), close thread
                if (pane_module != 'MessagePane' || pane_module == 'MessagePane' && data.current_pane != 'MessagePane') {
                    vent.trigger('ThreadLayout:close', { leave_rdrawer_open : true });
                }
            }

            vent.trigger(pane_module + ':show');
            data.current_pane = pane_module;
            data.last_pane = pane_module;

            if (!from_pop_state) {
                var state = {
                    right_drawer: pane_id
                };
                vent.trigger("Page:push_state", state);
            }

            // scroll down if we are on mobile and have a scrolltop value in localStorage
            if (MoshPit.get_size() == 'mobile') {
                var scrolltop = localStorage.getItem("right_drawer_scrolltop");
                if (scrolltop) {
                    scrolltop = parseInt(scrolltop, 10);
                    window.scroll(0, scrolltop);
                }
            }
        },
        hide: function() {
            // this if is pretty important to prevent an infinite loop
            // ThreadLayout:close() calls RightDrawer:hide()
            if ($('body').hasClass('right-drawer-shown')) {
                self.$el.hide();
                events.hide_pane();
                if (MoshPit.get_size() == 'mobile') {
                    vent.trigger('ThreadLayout:close');
                }
            }
        },
        hide_pane: function(obj) {
            var exclude_pane = (obj && obj.exclude_pane) ? obj.exclude_pane : null;
            // TODO this really should be: self.$el.find('.pane-view').hide(); moshpit has a problem w it though...
            self.$el.find('.pane-view').each(function() {
                var $pane = $(this);
                var pane_id = $pane.attr('id');
                if (exclude_pane && pane_id == exclude_pane) {
                    return true; // continue
                }
                if (pane_id == 'friend-pane') {
                    vent.trigger('FriendPane:cleanup');
                }
                $pane.hide();
            });
            data.current_pane = '';
        },
        close_if_mobile: function() {
            if (MoshPit.get_size() == 'mobile' && events.is_shown()) {
                events.hide();
            }
        },
        toggle_last: function() {
            if (!events.is_shown()) {
                events.show(data.last_pane);
            } else {
                events.hide();
            }
        }
    };

    this.addInitializer(function() {
        self.el  = 'right-drawer';
        self.$el = $('#' + self.el);

        MoshPit.join(self.$el);
        data.init();
        events.init();
    });
});
